import { useOwnerDocumentsQuery } from '../hooks/use-owner-documents'
import type { CatalogOwnerType } from '../models/document-owner'
import { DocumentGalleryTab } from './document-gallery-tab'
import { GalleryCopyFromDialog } from './gallery-copy-from-dialog'

/**
 * La pestaña de galería con el botón «Copiar desde…» montado.
 *
 * ── POR QUÉ ES UN ENVOLTORIO Y NO UN CAMBIO EN `DocumentGalleryTab` ─────────
 *
 * Porque la galería no tiene por qué saber que existe el reuso entre dueños: su trabajo es
 * mostrar las fotos de UN nivel y dejar acomodarlas. El reuso es una capacidad del consumidor, y
 * por eso entra por la prop `extraActions` que esa pestaña expone.
 *
 * Este envoltorio existe para que los cuatro paneles no repitan las mismas cuatro líneas —y sobre
 * todo para que no repitan el conteo, que es el dato que hace honesto al modo «Reemplazar»: sin
 * él, el diálogo diría «las fotos que ya están salen» sin decir cuántas son.
 *
 * ── EL CONTEO SALE DE LA CONSULTA QUE LA PESTAÑA YA HACE ────────────────────
 *
 * `useOwnerDocumentsQuery` con la misma clave: React Query devuelve la MISMA entrada de caché, así
 * que esto no agrega un viaje. Contar acá y no adentro de la pestaña es lo que evita tener que
 * subir el dato por props o bajar el diálogo al componente que no debería conocerlo.
 */
type GalleryTabWithCopyProps = {
  ownerType: CatalogOwnerType
  ownerId: string
  /** Cómo se nombra el dueño en el copy. En un subtipo es el CÓDIGO, no el nombre. */
  ownerLabel?: string
}

export function GalleryTabWithCopy({ ownerType, ownerId, ownerLabel }: GalleryTabWithCopyProps) {
  const documents = useOwnerDocumentsQuery({ ownerType, ownerId })
  const currentPhotoCount = (documents.data ?? []).filter(
    (document) => document.slot === 'gallery'
  ).length

  return (
    <DocumentGalleryTab
      ownerType={ownerType}
      ownerId={ownerId}
      ownerLabel={ownerLabel}
      extraActions={
        <GalleryCopyFromDialog
          ownerType={ownerType}
          ownerId={ownerId}
          currentPhotoCount={currentPhotoCount}
        />
      }
    />
  )
}
